'use strict';

var React = require('react');

var SvgRiskMinor = function SvgRiskMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 11a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm8.895 1.549-7-14.04c-.339-.679-1.45-.679-1.79 0l-7 14.04a1.004 1.004 0 0 0 .895 1.451h14a1 1 0 0 0 .895-1.451z"
  }));
};

exports.SvgRiskMinor = SvgRiskMinor;
